import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as Alert from '../../../../../components/Alert/Alert';
import { IInitialState } from '../../../../../reduxService';
import { useAppDispatch, useAppSelector } from '../../../../../reduxService/hooks';
import { IProjectMacra1 } from '../../../../MACRA_1/store/project/projectSlice';
import { IProjectMacra2 } from '../../../../MACRA_2/store/project/projectSlice';
import { getActionByProjectType } from '../../../../actionMap';
import { endpoint } from '../../../../pages';
import { cleanProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { INewButtonProps } from './INewButton';
import './NewButton.scss';

const NewButton = (props: INewButtonProps) => {
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch();

    const { cleanProject, selectProject, cleanResults } = getActionByProjectType();

    const project: IInitialState<IProjectMacra1 | IProjectMacra2> = useAppSelector(selectProject as any);
    const navigate = useNavigate();

    const handleClick = () => {
        if (project.initialState) {
            navigate(endpoint.projectInfo);
        } else {
            Alert.warning(t('header_new_button_alert_title'), t('header_new_button_alert_body') as string, true).then(result => {
                if (result.isConfirmed) {
                    dispatch(cleanProjectInfo());
                    dispatch(cleanProject());
                    dispatch(cleanResults());
                    navigate(endpoint.projectInfo);
                }
            });
        }
    };
    return (
        <button type='button' className={props.className} onClick={handleClick}>
            <i className='fa-solid fa-plus' />
            {t('header_new_button')}
        </button>
    );
};

export default NewButton;
